import { Component, OnInit, ChangeDetectorRef, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService, LanguageService, ApplicationService } from '../shared/services/index';
import { PeopleService } from '../shared/services/people.service';
import { HomeButton, Person } from '../shared/models/index';
import { ModalComponent } from '../modal/modal.component';
import { ApplicationType, SelectorComponent } from '../utils/index';

@Component({
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.scss'],
  standalone: false
})
export class AdminHomeComponent implements OnInit {
  public currentPerson!: Person;
  public languages: any[] = [];
  public currentLanguage!: string;
  buttons$!: Observable<HomeButton[]>;
  private applicationTypes: any[] = [];
  @ViewChild('languagesModal', { static: true }) languageModal!: ModalComponent;
  @ViewChild('appModal', { static: true }) appModal!: ModalComponent;

  @HostListener('window:storage')
  onStorageChange() {
    this.cdf.detectChanges();
  }

  constructor(
    private peopleService: PeopleService,
    private authService: AuthService,
    private cdf: ChangeDetectorRef,
    private language: LanguageService,
    private applicationService: ApplicationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.applicationService.getApplicationTypes().subscribe((types) => {
      this.applicationTypes = types.map((t: any) => Object.assign({}, t));
      this.applicationTypes.forEach((app) => {
        this.language.getValueByKey(app.Label).subscribe((label) => {
          app.Label = label;
        });
      });
    });

    this.currentLanguage = this.language.get();
    this.peopleService.getCurrent().subscribe((data) => {
      this.currentPerson = data;
      if (!this.currentLanguage) {
        this.currentLanguage = data.language ? data.language : 'en';
      }
    });

    this.language.getLanguages().subscribe((data) => {
      this.languages = data;
    });

    this.buttons$ = this.applicationService.getHomeButtons();
  }

  logout() {
    this.authService.logout().subscribe(() => {
      this.peopleService.logout();
    });
  }

  public openLanguagesSelector(): void {
    const languageIndex = this.languages.findIndex((l) => l === this.language.get());
    this.languageModal.modalFooter = false;
    this.languageModal.modalHeader = false;
    this.languageModal.modalMessage = false;
    this.languageModal.open(SelectorComponent, {
      values: this.languages,
      selectedIndex: languageIndex
    });
  }

  public selectLanguagesMenu(item: any) {
    this.language.set(item.value.toLowerCase());
    this.currentLanguage = item.value.toLowerCase();
  }

  public openAppSelector(): void {
    const appIndex = this.applicationTypes.findIndex((t) => t.Value === this.currentAppType);
    this.appModal.modalFooter = false;
    this.appModal.modalHeader = false;
    this.appModal.modalMessage = false;
    this.appModal.open(SelectorComponent, {
      values: this.applicationTypes
        .filter((t) => this.currentPerson.applicationTypes.includes(t.Value))
        .map((t) => t.Label),
      selectedIndex: appIndex
    });
  }

  public selectAppMenu(item: any) {
    const selectedApplicationType = this.applicationTypes[item.selectedIndex].Value;
    if (selectedApplicationType !== this.currentAppType) {
      this.applicationService.setApplicationType(selectedApplicationType).subscribe(() => {
        window.location.reload();
      });
    }
  }

  public goToDashboard() {
    this.router.navigate(['/inspectionbrowser']);
  }

  public goToInspections() {
    this.router.navigate(['/inspectionbrowser/inspections/all']);
  }

  openLink(link: string) {
    window.open(link, '_blank');
  }

  get isOptimization() {
    return this.currentAppType === ApplicationType.Optimization;
  }

  get isInstallation() {
    return this.currentAppType === ApplicationType.Installation;
  }

  get currentAppType(): number {
    return this.applicationService.applicationType;
  }

  get inspectionsLabel() {
    return `home.inspection-${this.currentAppType}-list`;
  }
}
